module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_3072.f682f823.webp";